import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Button, Image } from "hesus-ui-kit";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import deleteIcon from "@icons/ic-delete-red.svg";
import ParametersFormat from "./ParametersFormat";
import AddEditSpecificCondition from "../../../AddEditQuote/components/SpecificConditionPopup/AddEditSpecificCondition";
import {
  GenrealInfo,
  GridRow,
  PaddingDiv,
  NoContact,
  ListTitle,
  ListSubTitle,
  ListContent,
  ContentAsTitle,
  FlexHeader,
  ContainerLabel,
} from "./QuoteSpecificCondition.styled";
import "../../../AddEditQuote/AddEditQuote.scss";

import { Title, FlexRowHeader } from "../../QuoteView.styled";
import { RequiredMessagePara } from "@utils/extra-style";

const QuoteSpecificCondition = (props) => {
  const {
    t,
    data,
    page,
    conditionData,
    setConditionData,
    additionalCondition,
    setAdditionalCondition,
    formData,
  } = props;

  const [isAddEditSpecificConditionPopup, setIsAddEditSpecificConditionPopup] =
    useState(false);

  const [popUpConditionData, setPopUpConditionData] = useState(conditionData);

  const createConditionObject = (
    conditions,
    type,
    specificCondition,
    parentId
  ) => {
    if (type === "parent") {
      const conditionObject = {
        id: conditions.id,
        parametersValue: conditions.parametersValue,
        parent: conditions.specificCondition?.parent,
        children: [],
      };
      const newConditions = {
        ...conditions.specificCondition,
        parametersValue: conditions.parametersValue,
        childId: conditions.id,
      };
      conditionObject.children.push(newConditions);
      return conditionObject;
    }
    if (type === "child") {
      const conditionObject = specificCondition.find(
        (condition) =>
          parseInt(condition.parent.id, 10) === parseInt(parentId, 10)
      );
      if (conditions.parametersValue !== "") {
        conditionObject.parametersValue = conditions.parametersValue;
      }
      const newConditions = {
        ...conditions.specificCondition,
        parametersValue: conditions.parametersValue,
        childId: conditions.id,
      };

      conditionObject.children.push(newConditions);
      return conditionObject;
    }
    if (type === "selfparent") {
      const conditionObject = {
        id: conditions.id,
        parametersValue: conditions.parametersValue,
        parent: conditions.specificCondition,
        children: [],
      };
      const newConditions = {
        ...conditions.specificCondition,
        parametersValue: conditions.parametersValue,
        childId: conditions.id,
      };
      conditionObject.children.push(newConditions);
      return conditionObject;
    }
  };

  const onAddEditClick = () => {
    setIsAddEditSpecificConditionPopup(true);
  };

  useEffect(() => {
    const specificCondition = [];
    const specificConditionIds = [];
    if (data && data.length > 0) {
      data.map((condition) => {
        if (condition.specificCondition.parent?.id) {
          const parentId = condition.specificCondition.parent?.id;
          if (specificConditionIds.indexOf(parentId) === -1) {
            specificConditionIds.push(parentId);
            specificCondition.push(
              createConditionObject(
                condition,
                "parent",
                specificCondition,
                parentId
              )
            );
          } else {
            createConditionObject(
              condition,
              "child",
              specificCondition,
              parentId
            );
          }
        }
        if (!condition.specificCondition.parent?.id) {
          specificCondition.push(
            createConditionObject(
              condition,
              "selfparent",
              specificCondition,
              null
            )
          );
        }
      });
      setConditionData(specificCondition);
      setPopUpConditionData(specificCondition);
    }
  }, [data]);

  const deleteCondition = (parentId, childId, type, source = "view") => {
    const selectedConditionData =
      source === "popup" ? popUpConditionData : conditionData;
    if (type === "child") {
      const newConditionData = selectedConditionData.map((data) => {
        if (data.parent.id === parentId && data.children?.length > 0) {
          return {
            ...data,
            children: data.children.filter(
              (childData) => childData.id !== childId
            ),
          };
        }
        if (data.parent.id !== parentId) {
          return data;
        }
      });
      setPopUpConditionData(newConditionData);
      if (source === "view") {
        setConditionData(newConditionData);
      }
    }
    if (type === "parent") {
      const newConditionData = conditionData.filter(
        (data) => data.parent.id !== parentId
      );
      setPopUpConditionData(newConditionData);
      if (source === "view") {
        setConditionData(newConditionData);
      }
    }
  };

  const addCondition = (parentId, condition, type) => {
    if (type === "parent") {
      const newConditions = {
        ...condition,
        parametersValue: "",
        childId: null,
      };
      const newParent = {
        id: null,
        parent: condition,
        children: [newConditions],
      };

      setPopUpConditionData([...popUpConditionData, newParent]);
    }
    if (type === "child") {
      const parent = popUpConditionData.find(
        (data) => parseInt(data.parent.id, 10) === parseInt(parentId, 10)
      );
      if (parent !== undefined) {
        const newConditionData = popUpConditionData.map((data) => {
          if (data.parent.id === parentId) {
            data.children.push(condition);
          }
          return data;
        });
        setPopUpConditionData(newConditionData);
      } else {
        const parentObject = {
          id: null,
          parametersValue: null,
          parent: condition.parent,
          children: [],
        };
        parentObject.children.push(condition);
        setPopUpConditionData([...popUpConditionData, parentObject]);
      }
    }
  };

  const addParameters = (parentId, condition, key, value) => {
    const parent = popUpConditionData.find(
      (data) => data.parent.id === parentId
    );
    if (parent !== undefined) {
      const newConditionData = popUpConditionData.map((data) => {
        if (data.parent.id === parentId) {
          return {
            ...data,
            children: data.children.map((child) => {
              if (child.id === condition.id) {
                let parametersValue = child.parametersValue
                  ? JSON.parse(child.parametersValue)
                  : {};
                parametersValue[key] = value;
                child.parametersValue = JSON.stringify(parametersValue);
              }
              return child;
            }),
          };
        }
        if (data.parent.id !== parentId) return data;
      });
      setPopUpConditionData(newConditionData);
    }
  };

  const verifyConditionParams = () => {
    let formError = 0;
    const newConditionData = popUpConditionData.map((data) => {
      return {
        ...data,
        children: data.children.map((childData) => {
          const parametersError = {};
          if (childData?.parameters !== "" && childData?.parameters !== null) {
            const { parameters } = JSON.parse(childData?.parameters);
            const paramsValue =
              childData?.parametersValue !== ""
                ? JSON.parse(childData?.parametersValue)
                : null;
            Object.keys(parameters).forEach((key) => {
              if (
                !paramsValue ||
                !paramsValue.hasOwnProperty(key) ||
                (paramsValue.hasOwnProperty(key) &&
                  (paramsValue[key] === "" || paramsValue[key] === null))
              ) {
                formError = 1;
                parametersError[key] = 1;
              }
            });
          }
          return {
            ...childData,
            parametersError,
          };
        }),
      };
    });
    setPopUpConditionData(newConditionData);
    if (!formError) {
      setConditionData(popUpConditionData);
      setIsAddEditSpecificConditionPopup(false);
    }
  };

  const onPopUpClose = () => {
    setPopUpConditionData(conditionData);
    setIsAddEditSpecificConditionPopup(false);
  };

  const onPopUpValidate = () => {
    verifyConditionParams();
  };

  return (
    <GenrealInfo marginTop={page === "view" ? "10px;" : "0px;"}>
      {page === "view" && (
        <FlexRowHeader>
          <Title>{t("QUOTE_SECTION_SPECIFIC_CONDITIONS")}</Title>
        </FlexRowHeader>
      )}
      {page === "create" && (
        <FlexHeader>
          <Title>{t("QUOTE_SECTION_SPECIFIC_CONDITIONS")}</Title>

          <Button
            onClick={onAddEditClick}
            styles={{
              backgroundColor: "white",
              color: "#008395",
              border: "1px solid #008395",
              height: "auto",
              width: "auto",
              padding: "1px 4px 1px 4px",
              "&:hover": {
                backgroundColor: "white",
              },
            }}
          >
            {t("QUOTE_ADD_SPECIFIC_CONDITIONS")}
          </Button>
        </FlexHeader>
      )}
      <PaddingDiv>
        {((conditionData && conditionData?.length !== "") ||
          conditionData?.length !== 0) && (
          <GridRow column="1fr" marginBottom="0px" gridGap="0rem">
            {conditionData?.map((conditions) => {
              return (
                <React.Fragment key={"quote-conditions-child" + conditions.id}>
                  {!!conditions?.children?.length > 0 && (
                    <ul key={"quote-conditions" + conditions.id}>
                      {!!conditions?.parent?.isTitle && (
                        <>
                          <ListTitle>{conditions?.parent.title} </ListTitle>

                          {!!conditions?.children?.length > 0 &&
                            conditions?.children?.map((childInfo) => {
                              return (
                                <React.Fragment
                                  key={
                                    "quote-conditions-child" +
                                    conditions.id +
                                    childInfo.id
                                  }
                                >
                                  <ListSubTitle className="add-quote__liImage">
                                    {page === "create" && (
                                      <Image
                                        src={deleteIcon}
                                        alt={t(
                                          "QUOTE_SPECIFIC_CONDITION_DELETE_TOOLTIP"
                                        )}
                                        title={t(
                                          "QUOTE_SPECIFIC_CONDITION_DELETE_TOOLTIP"
                                        )}
                                        onClick={() =>
                                          deleteCondition(
                                            conditions?.parent.id,
                                            childInfo.id,
                                            conditions?.children?.length > 1
                                              ? "child"
                                              : "parent"
                                          )
                                        }
                                        className="add-quote-specific-condition__image-icon"
                                      />
                                    )}
                                    {!!childInfo.title && childInfo.title}
                                    {!childInfo.title && (
                                      <ContentAsTitle>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: childInfo.content,
                                          }}
                                        ></div>
                                      </ContentAsTitle>
                                    )}
                                  </ListSubTitle>
                                  {!!childInfo.content && !!childInfo.title && (
                                    <ListContent>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: childInfo.content,
                                        }}
                                      ></div>
                                    </ListContent>
                                  )}
                                  {!!childInfo.parametersValue && (
                                    <ParametersFormat
                                      parametersFormat={
                                        conditions?.parent?.parameters &&
                                        conditions?.parent?.parameters !== ""
                                          ? conditions?.parent?.parameters
                                          : childInfo?.parameters
                                      }
                                      parametersValue={
                                        childInfo?.parametersValue
                                      }
                                    />
                                  )}
                                </React.Fragment>
                              );
                            })}
                        </>
                      )}
                      {!conditions?.parent?.isTitle && (
                        <>
                          {!!conditions?.children?.length > 0 &&
                            conditions?.children?.map((childInfo) => {
                              return (
                                <React.Fragment
                                  key={
                                    "quote-conditions-child" +
                                    conditions.id +
                                    childInfo.id
                                  }
                                >
                                  <ListTitle>
                                    {page === "create" && (
                                      <Image
                                        src={deleteIcon}
                                        alt={t(
                                          "QUOTE_SPECIFIC_CONDITION_DELETE_TOOLTIP"
                                        )}
                                        title={t(
                                          "QUOTE_SPECIFIC_CONDITION_DELETE_TOOLTIP"
                                        )}
                                        onClick={() =>
                                          deleteCondition(
                                            conditions?.parent.id,
                                            childInfo.id,
                                            "parent"
                                          )
                                        }
                                        className="add-quote-specific-condition__image-icon"
                                      />
                                    )}
                                    {childInfo.title}
                                  </ListTitle>
                                  {!!childInfo.content && (
                                    <ListContent>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: childInfo.content,
                                        }}
                                      ></div>
                                    </ListContent>
                                  )}
                                  {!!childInfo.parametersValue && (
                                    <ParametersFormat
                                      parametersFormat={
                                        conditions?.parent?.parameters &&
                                        conditions?.parent?.parameters !== ""
                                          ? conditions?.parent?.parameters
                                          : childInfo?.parameters
                                      }
                                      parametersValue={
                                        childInfo?.parametersValue
                                      }
                                      addParameters={addParameters}
                                    />
                                  )}
                                </React.Fragment>
                              );
                            })}
                        </>
                      )}
                    </ul>
                  )}
                </React.Fragment>
              );
            })}
            {page === "view" &&
              additionalCondition !== "" &&
              additionalCondition !== null && (
                <ul>
                  <ListTitle>{t("QUOTE_ADDITIONAL_CONDITIONS")} </ListTitle>
                  {!!additionalCondition && (
                    <ListContent>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: additionalCondition,
                        }}
                      ></div>
                    </ListContent>
                  )}
                </ul>
              )}
            {page === "create" && (
              <>
                <GridRow column="1fr">
                  <ContainerLabel color="#00aeea">
                    {t("QUOTE_ADDITIONAL_CONDITIONS")}
                  </ContainerLabel>
                </GridRow>
                <GridRow column="1fr">
                  <CKEditorText
                    descriptionData={additionalCondition}
                    setDescriptionData={setAdditionalCondition}
                  />
                  {formData.additionalSpecificConditions.error && (
                    <RequiredMessagePara>
                      {formData.additionalSpecificConditions.error}
                    </RequiredMessagePara>
                  )}
                </GridRow>
              </>
            )}
          </GridRow>
        )}
        {page === "view" &&
          (additionalCondition === "" || additionalCondition === null) &&
          (conditionData === null ||
            conditionData?.length === "" ||
            conditionData?.length === 0) && (
            <GridRow column="1fr">
              <NoContact color={page === "view" ? "#cccccc" : "#767676"}>
                {t("QUOTE_NO_SPECIFIC_CONDITIONS")}
              </NoContact>
            </GridRow>
          )}
      </PaddingDiv>
      {isAddEditSpecificConditionPopup && (
        <AddEditSpecificCondition
          conditionData={popUpConditionData}
          addCondition={addCondition}
          deleteCondition={deleteCondition}
          onPopUpClose={onPopUpClose}
          onPopUpValidate={onPopUpValidate}
          addParameters={addParameters}
        />
      )}
    </GenrealInfo>
  );
};

QuoteSpecificCondition.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};
QuoteSpecificCondition.defaultProps = {
  page: "view",
};

export default withTranslation()(QuoteSpecificCondition);
